import { twMerge } from '@panwds/tailwindcss';
import React from 'react';
import { TruncateText } from '../TruncateText/index.js';
const sizeVariants = {
    xxs: 'twds-text-base twds-font-medium',
    xs: 'twds-text-lg twds-font-semibold',
    sm: 'twds-text-xl twds-font-normal',
    md: 'twds-text-2xl twds-font-light',
    lg: 'twds-text-3xl twds-font-light',
    xl: 'twds-text-4xl twds-font-light',
    xxl: 'twds-text-5xl twds-font-light'
};
/**
 * Renders a styled heading element, used for titles and headings.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Title } from "@panwds/react-ui";
 * ```
 *
 * @replacement `@panwds/react-aria-components#Heading`
 */
export function Title({ addClassName, children, dataMetrics, dataTestId, level, size = 'md', truncate = false, ...passThrough }) {
    const Component = `h${level}`;
    const className = twMerge('twds-font-lato twds-text-default dark:twds-text-gray-100 twds-box-border twds-m-0 twds-pl-0 twds-pr-0 twds-pt-0 twds-pb-0 twds-border-0', sizeVariants[size], truncate && 'twds-flex', addClassName);
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": dataTestId || `title-${level}${size && `-${size}`}`, className: className, ...passThrough }, truncate ? React.createElement(TruncateText, null, children) : children));
}
//# sourceMappingURL=Title.js.map